import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { TOneTwoTripCarouselSlide } from '../../containers/OneTwoTripCarouselContainer/useOneTwoTripCarousel';
import { ElementInViewport } from '../element_in_viewport';
import { ItemsCarousel } from '../ItemsCarousel';

import * as styles from './OneTwoTripCarousel.css';
import { OneTwoTripSlide } from './OneTwoTripSlide';

interface IOneTwoTripCarouselProps {
  slides: TOneTwoTripCarouselSlide[];
  onSlideClick(slide: TOneTwoTripCarouselSlide): void;
  onSlideShow(label: string): void;
}

export const OneTwoTripCarousel: React.VFC<IOneTwoTripCarouselProps> = ({ slides, onSlideClick, onSlideShow }) => (
  <section data-testid="OneTwoTripCarousel">
    <div className="cg-container-fluid-xs">
      <div className={styles['header']}>
        <UIHeading1>Популярные направления</UIHeading1>
      </div>
      <ItemsCarousel scrollVisible arrowVerticalOffset={-33}>
        {slides.map(slide => (
          <ElementInViewport
            horizontal
            key={`${slide.cityName}-ott-slide`}
            onChange={isVisible => {
              if (isVisible) {
                onSlideShow(slide.analyticsLabel);
              }
            }}
          >
            <OneTwoTripSlide
              cityName={slide.cityName}
              imageUrl={slide.imageUrl}
              price={slide.price}
              text={slide.text}
              onClick={() => onSlideClick(slide)}
            />
          </ElementInViewport>
        ))}
      </ItemsCarousel>
    </div>
  </section>
);
